import {BrowserRouter, Route, Routes} from "react-router-dom";
import {mainRoute} from "./routes";
import React, {Suspense} from "react";
import {ToastContainer} from "react-toastify";
import {AuthContextProvider} from "./context/AuthContext";
import Loading from "./components/Loading";
import SweetAlertContextProvider from "./context/sweetAlertContext";
import {ToggleSidebarContextProvider} from "./context/toggleSidebarContext";
import {isApp} from "./utils/helper";

export default function App() {
    window.addEventListener("error", (e) => {
        if (e.message && e.message.includes("Loading chunk")) {
            console.warn("ChunkLoadError detected, reloading page...");
            window.location.reload(); // رفرش صفحه
        }
    });

    React.useEffect(() => {
        if (isApp() && window.location.pathname !== '/update-app') {
            try {
                window.AndroidVersionInterface.check(process.env.REACT_APP_ANDROID_VERSION);
            } catch {
                window.location.href = '/update-app';
            }
        }
    }, []);
    return (
        <ToggleSidebarContextProvider>
            <AuthContextProvider>
                <SweetAlertContextProvider>
                    <Suspense fallback={<Loading/>}>
                        <BrowserRouter>
                            <Routes>
                                {
                                    mainRoute.map(route => {
                                        return <Route path={route.path} key={route.id}
                                                      element={<route.component/>}/>
                                    })
                                }
                            </Routes>
                            <ToastContainer
                                rtl={true}
                                theme="colored"
                            />
                        </BrowserRouter>
                    </Suspense>
                </SweetAlertContextProvider>
            </AuthContextProvider>
        </ToggleSidebarContextProvider>
    );
}
